module.exports = __webpack_public_path__ + "static/media/flag.e6be1c55.png";